var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_c('playable-history-export', { attrs: { "config": _vm.detailDialog, "handlePreview": _vm.handlePreview || _vm.detailDialog.handlePreview } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };